import {
  ARIA_EXPANDED_ATTRIBUTE,
  AUX_CONTAINER_SELECTOR,
  OVERFLOW_DRAWER_SELECTOR,
} from './useEditorToolbarOverflowClose.constants'

export function isAriaExpanded(element) {
  return element.getAttribute(ARIA_EXPANDED_ATTRIBUTE) === 'true'
}

export function getAuxContainers() {
  return [...document.querySelectorAll(AUX_CONTAINER_SELECTOR)]
}

export function getOverflowDrawer(container) {
  return container.querySelector(OVERFLOW_DRAWER_SELECTOR)
}

export function isDrawerOpen(chevron, container) {
  if (isAriaExpanded(chevron)) {
    return true
  }

  const drawer = getOverflowDrawer(container)

  return Boolean(drawer && drawer.childElementCount > 0)
}

export function shouldIgnoreMouseDown({
  auxContainers,
  chevron,
  container,
  drawer,
  target,
}) {
  return (
    !chevron ||
    !isDrawerOpen(chevron, container) ||
    chevron.contains(target) ||
    drawer?.contains(target) ||
    auxContainers.some(auxContainer => auxContainer.contains(target))
  )
}
